import { Link } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { Phone, MapPin, MessageCircle } from "lucide-react";

const WHATSAPP = process.env.REACT_APP_WHATSAPP_NUMBER;

export default function Footer() {
  const { t, lang } = useApp();
  return (
    <footer className="bg-[#1c1917] text-stone-200 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="text-[11px] tracking-[0.2em] text-[#e69138] uppercase mb-3">SVRM</div>
          <h3 className="text-xl font-semibold mb-3">
            {lang === "en" ? "Sri Venkateswara Rice Mill" : "శ్రీ వెంకటేశ్వర రైస్ మిల్"}
          </h3>
          <p className="text-sm text-stone-400 leading-relaxed">{t.footer.tagline}</p>
        </div>

        <div>
          <div className="text-[11px] tracking-[0.2em] text-[#e69138] uppercase mb-3">
            {t.footer.quickLinks}
          </div>
          <ul className="space-y-2 text-sm text-stone-300">
            <li><Link data-testid="footer-home" to="/" className="hover:text-white">{t.nav.home}</Link></li>
            <li><Link data-testid="footer-products" to="/products" className="hover:text-white">{t.nav.products}</Link></li>
            <li><Link data-testid="footer-contact" to="/contact" className="hover:text-white">{t.nav.contact}</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-[11px] tracking-[0.2em] text-[#e69138] uppercase mb-3">
            {t.footer.contact}
          </div>
          <ul className="space-y-3 text-sm text-stone-300">
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 text-[#e69138]" /> F. K. Palem, Andhra Pradesh</li>
            <li>
              <a
                href={`https://wa.me/${WHATSAPP}`}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-wa-1"
                className="inline-flex items-center gap-2 hover:text-white"
              >
                <MessageCircle size={16} className="text-[#e69138]" /> +91 89777 53672
              </a>
            </li>
            {process.env.REACT_APP_SECONDARY_PHONE && (
              <li>
                <a
                  href={`https://wa.me/${process.env.REACT_APP_SECONDARY_PHONE}`}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-wa-2"
                  className="inline-flex items-center gap-2 hover:text-white"
                >
                  <MessageCircle size={16} className="text-[#e69138]" /> +91 70139 16731
                </a>
              </li>
            )}
          </ul>
        </div>
      </div>
      <div className="border-t border-stone-800 py-5 text-center text-xs text-stone-500">
        © {new Date().getFullYear()} Sri Venkateswara Rice Mill. {t.footer.rights}
      </div>
    </footer>
  );
}
